/**
 * collections-menu.js – Premium Attention Animation Controller
 * Only runs on mobile (≤749px). Slower 2‑second animation.
 */

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    if (window.innerWidth > 749) {
      console.log('Collections Menu: Skipping (desktop)');
      return;
    }

    const cards = document.querySelectorAll('.bn-card');
    if (cards.length < 2) {
      console.log('Collections Menu: Less than 2 cards found');
      return;
    }

    console.log('Collections Menu: Initialized on mobile with', cards.length, 'cards');

    const FIRST_CARD = cards[0];
    const SECOND_CARD = cards[1];

    // 🕒 2‑second animation duration (must match CSS)
    const ANIMATION_DURATION = 2000;
    const GAP_BETWEEN_CARDS = 300;      // small pause after first before second starts
    const SEQUENCE_DELAY = 12000;       // repeat every 12 seconds
    const INITIAL_DELAY = 500;          // wait 0.5s before first animation

    let isActive = true;
    let timeoutId = null;

    function animateCard(card) {
      if (!card) return;
      card.classList.add('bn-card--attention');
      setTimeout(() => {
        card.classList.remove('bn-card--attention');
      }, ANIMATION_DURATION);
    }

    function runSequence() {
      if (!isActive) return;

      animateCard(FIRST_CARD);

      setTimeout(() => {
        if (!isActive) return;
        animateCard(SECOND_CARD);
      }, ANIMATION_DURATION + GAP_BETWEEN_CARDS);

      timeoutId = setTimeout(() => {
        runSequence();
      }, SEQUENCE_DELAY);
    }

    function stopAnimations() {
      if (!isActive) return;
      isActive = false;
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      cards.forEach(c => c.classList.remove('bn-card--attention'));
    }

    const interactionEvents = ['scroll', 'touchstart', 'click', 'keydown'];
    interactionEvents.forEach(ev => {
      document.addEventListener(ev, stopAnimations, { passive: true });
    });

    setTimeout(() => {
      if (isActive) runSequence();
    }, INITIAL_DELAY);
  }
})();